export const MAINPAGE_ROUTE = "/";
export const ABOUTUS_ROUTE = "/aboutus";
export const MEMBERSHIP_ROUTE = "/membership";
export const FAQ_ROUTE = "/faq";
export const ERROR_PAGE = '/error';
export const PRIVACY_POLICY_ROUTE = "/privacy-policy";
export const COOKIE_SETTINGS_ROUTE = "/cookie-policy";
export const LEGAL_PAGE_ROUTE = "/legal";
export const RISK_WARNINGS_ROUTE = "/risk-warnings";
